import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import ET3PageDiv from "../../../core/et3-page-div";
import React from "react";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import Form from "./form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import Et3Table from "../../../core/et3-table";
import { KHATTABAT_REMUNERATIONS } from "../../../constants/table-custom-headers/Khattabat";
import getKhattabatSelectsStore from "../../../stores/khattabat-stores/selects-store";

const KhattabatRemuneration = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_REMUNERATION",
      "KHATTABAT_REMUNERATION"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT_REMUNERATION")}
        subTitle={i18n.get("PER_CYCLE")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Form />
      <Et3Margin top={10} bottom={10} left={0} right={0} />

      <Et3Table
        columns={KHATTABAT_REMUNERATIONS}
        title={`${i18n.get("ADMIN_KHATTABAT_REMUNERATIONS")}`}
        rows={getKhattabatSelectsStore().khattabatAdminsRenumerations.get()}
        shouldBeFlagged={false}
        titleKey={"KHATTABAT_ADMIN_REMUNERATIONS_PER_CYCLE"}
      />
    </ET3PageDiv>
  );
});
export default KhattabatRemuneration;
